<template>
  <v-container class="container-card">
    <v-card>
      <tabela-aprovacao-campanhas></tabela-aprovacao-campanhas>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import TabelaAprovacaoCampanhas from "@/components/aprovacao/TabelaAprovacaoCampanhas.vue";

export default {
  name: "AprovacaoCampanha",

  components: {
    TabelaAprovacaoCampanhas
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Aprovação de Campanha");
  }
};
</script>
